import { connect } from 'react-redux'
import { Map } from 'immutable'
import toJS from '../general/toJS'
import config from '../../config.json'
import { reorderListItems } from '../../functions/lists'
import { 
    collectionUpdateItemItems,
    collectionUpdateItemEditedTrue,
    collectionUpdateItemEditedFalse
} from '../../actions'
import CollectionDropzone from '../../components/PageEditSelection/CollectionDropzone'
import Collection from '../../components/PageEditSelection/Collection'
// import getNewSpellingForDates from '../../functions/getNewSpellingForDates'
import getPeriodesWeek from '../../functions/getPeriodesWeek'
import getData from '../../functions/getData'
import { PROGRAM_CINEMAS, 
    PROGRAM_ADS_ITEMS, 
    PROGRAM_CLI_MOVIES_ITEMS, 
    PROGRAM_COLLECTIONS_ITEMS, 
    PROGRAM_HIGHLIGHTS, 
    PROGRAM_MOVIEMAPPING_ITEMS, 
    PROGRAM_MOVIEEXTENSIONS_ITEMS, 
    PROGRAM_PY_MOVIES_ITEMS, UI_PROGRAM, 
    PROGRAM_KH_MOVIES_ITEMS, 
    PROGRAM_ATTRIBUTES, 
    PROGRAM_WEISCHERAD_ITEMS,
    PROGRAM_COMP_MOVIES_ITEMS,
    PROGRAM_ADVERTISEMENTS_ITEMS,
    PROGRAM_DIESEL_MOVIES_ITEMS,
    AUTH_CAPS,
    PROGRAM_CORTEC_MOVIES_ITEMS,
    PROGRAM_VISTA_MOVIES_ITEMS,
    PROGRAM_MARSX_MOVIES_ITEMS
} from '../../constants/state'
import sortCinemas from '../../functions/sortCinemas'
import canEditProgram from '../../functions/canEditProgram'
import { ADVERTISEMENT_HOME_BANNER, ADVERTISEMENT_HOME_BANNER_SINGLE } from '../../constants/advertisementTypes'
import selectionTypes from '../../constants/itemSelectionsDisplayTypes'

const updateCollectionItems = (dispatch, id, newItems) => {
    dispatch(collectionUpdateItemItems(id, newItems))
    dispatch(collectionUpdateItemEditedTrue(id))
}

const getCollectionItems = ownProps => ownProps.collection.get('items')

const mapDispatchToProps = (dispatch, ownProps) => ({
    addItemToCollection: (collectionID, itemID, itemType) => {
        const newItemsList = getCollectionItems(ownProps).push(Map({
            id: itemID,
            type: itemType
        }))

        updateCollectionItems(dispatch, ownProps.id, newItemsList)
    },
    removeItemFromCollection: (itemID) => {
        const itemIdString = itemID.toString()
        const newItemsList = getCollectionItems(ownProps).filter(item => item.get('id').toString() !== itemIdString.toString())
        updateCollectionItems(dispatch, ownProps.id, newItemsList)
    },
    reorderCollectionItems: (dragIndex, hoverIndex) => {
        const newItemsList = reorderListItems(getCollectionItems(ownProps), dragIndex, hoverIndex)
        updateCollectionItems(dispatch, ownProps.id, newItemsList)
    },
    setEditedFalse: () => dispatch(collectionUpdateItemEditedFalse(ownProps.id))
})

const mapStateToProps = (state, ownProps) => ({
    collection: getData(state, PROGRAM_COLLECTIONS_ITEMS).get(ownProps.id.toString()),
    displayDropzones: getData(state, [UI_PROGRAM, 'activeDropzones']),
    cliCinemas: getData(state, PROGRAM_CINEMAS),
    cliMovies: getData(state, PROGRAM_CLI_MOVIES_ITEMS),
    adsItems: getData(state, PROGRAM_ADS_ITEMS),
    advertisementsItems: getData(state, PROGRAM_ADVERTISEMENTS_ITEMS),
    highlightsItems: getData(state, PROGRAM_HIGHLIGHTS),
    weischerAdsItems: getData(state, PROGRAM_WEISCHERAD_ITEMS),
    pyMovies: getData(state, PROGRAM_PY_MOVIES_ITEMS),
    dieselMovies: getData(state, PROGRAM_DIESEL_MOVIES_ITEMS),
    cortecMovies: getData(state, PROGRAM_CORTEC_MOVIES_ITEMS),
    khMovies: getData(state, PROGRAM_KH_MOVIES_ITEMS),
    compesoMovies: getData(state, PROGRAM_COMP_MOVIES_ITEMS),
    vistaMovies: getData(state, PROGRAM_VISTA_MOVIES_ITEMS),
    marsxMovies: getData(state, PROGRAM_MARSX_MOVIES_ITEMS),
    movieMappings: getData(state, PROGRAM_MOVIEMAPPING_ITEMS),
    movieExtensions: getData(state, PROGRAM_MOVIEEXTENSIONS_ITEMS),
    attributes: getData(state, PROGRAM_ATTRIBUTES),
    caps: getData(state, AUTH_CAPS)
})

const CollectionContainer = ({
    id, 
    collection, 
    selectionsCinema, 
    selectionsCinemasFilter, 
    displayDropzones, 
    attributes, 
    dieselMovies,
    cortecMovies,
    pyMovies, 
    khMovies, 
    compesoMovies,
    vistaMovies,
    marsxMovies,
    movieExtensions, 
    setEditedFalse, 
    movieMappings, 
    filterValue, 
    filterType, 
    addItemToCollection, 
    removeItemFromCollection, 
    reorderCollectionItems, 
    selectionID,
    selectionType, 
    cliCinemas, 
    cliMovies, 
    adsItems, 
    advertisementsItems,
    highlightsItems, 
    weischerAdsItems,
    caps
}) => {
    const { edited , dateStart, dateEnd, items } = collection
    const weekOfYear= getPeriodesWeek(dateStart)
    const sortedCinemasIds = sortCinemas(selectionsCinema, cliCinemas, selectionsCinemasFilter)

    const canEdit = canEditProgram(caps)

    const HOME_BANNER_CONFLICT = {
        [ADVERTISEMENT_HOME_BANNER]: ADVERTISEMENT_HOME_BANNER_SINGLE,
        [ADVERTISEMENT_HOME_BANNER_SINGLE]: ADVERTISEMENT_HOME_BANNER,
    }

    const adCanDropCallback = (props, sourceObj) => {
        const draggedAd = advertisementsItems[sourceObj.id]
        if (!draggedAd) return true
        const conflictType = HOME_BANNER_CONFLICT[draggedAd.type]
        if (!conflictType) return true
        return !props.items.some(item => {
            const ad = advertisementsItems[item.id]
            return ad && ad.type === conflictType
        })
    }
    const basicUrlEdit = canEdit ? `${config.routes.program.path}/${selectionType}/${selectionID}` : false

    
    return (
        displayDropzones ? (
            <CollectionDropzone
                selectionType={selectionType}
                id={id}
                dateStart={dateStart}
                dateEnd={dateEnd}
                items={items}
                week={weekOfYear}
                addItemToCollection={addItemToCollection}
                canDropCallback={selectionTypes.ADVERTISEMENT === selectionType ? adCanDropCallback : undefined}
            />
        ) : (
            <Collection
                id={id}
                isEdited={edited}
                dateStart={dateStart}
                dateEnd={dateEnd}
                items={items}
                week={weekOfYear}
                setEditedFalse={setEditedFalse}
                sortedCinemasIds={sortedCinemasIds}
                removeItemFromCollection={removeItemFromCollection}
                basicUrlEdit={basicUrlEdit}
                reorderCollectionItems={reorderCollectionItems}
                movieMappings={movieMappings}
                cliMovies={cliMovies}
                cliCinemas={cliCinemas}
                movieExtensions={movieExtensions}
                pyMovies={pyMovies}
                dieselMovies={dieselMovies}
                cortecMovies={cortecMovies}
                khMovies={khMovies}
                compesoMovies={compesoMovies}
                vistaMovies={vistaMovies}
                marsxMovies={marsxMovies}
                filterType={filterType}
                filterValue={filterValue}
                highlightsItems={highlightsItems}
                adsItems={adsItems}
                advertisementsItems={advertisementsItems}
                weischerAdsItems={weischerAdsItems}
                attributes={attributes}
            />
        )
    )
}

export default connect(mapStateToProps, () => ({}))(connect(mapStateToProps, mapDispatchToProps)(toJS(CollectionContainer)))